"use client";

import { MenuItemType } from "./types";
import CsrHeader from "./index.csr";
import { useEffect, useState } from "react";

interface Props {
    menuData: MenuItemType[];
    menuUrl?: string;
    logoHref?: string;
    showTopBar?: boolean;
}

// Detects mobile breakpoint after mount to avoid headers() and still render correct layout.
// SSR renders desktop layout (links visible for crawlers), CSS hides it on small screens.
// After hydration, actual viewport is applied.
export function HeaderStaticClient({ menuData, menuUrl, logoHref, showTopBar = true }: Props) {
    const [viewport, setViewport] = useState<"mobile" | "desktop">("desktop");

    useEffect(() => {
        const mq = window.matchMedia("(max-width: 899px)");
        setViewport(mq.matches ? "mobile" : "desktop");
        const handler = (e: MediaQueryListEvent) => setViewport(e.matches ? "mobile" : "desktop");
        mq.addEventListener("change", handler);
        return () => mq.removeEventListener("change", handler);
    }, []);

    return (
        <CsrHeader
            menuData={menuData}
            menuUrl={menuUrl}

            viewport={viewport}
            showTopBar={showTopBar}
            logoHref={logoHref}
        />
    );
}
